/**
 * Generate Study Dialog Context
 *
 * Migrated from: lego/page/etmf/overview/generate-study/context/DialogContext.jsx
 *
 * React context for managing Generate Study wizard state across all steps.
 */

import { createContext } from 'react'

export interface SelectOption {
  value: number
  label: string
  id: number
  name: string
  mccObjUuid?: string
  mccParentObjUuid?: string
  realId?: number
  isCountry?: boolean
  isSite?: boolean
  siteIds?: string[]
  countryId?: string
}

export interface Selection {
  product?: SelectOption
  study?: SelectOption
  environment?: SelectOption
  countries: SelectOption[]
  sites: SelectOption[]
}

export interface FormValues {
  product: number | null
  study: number | null
  environment: number | null
  countries: number[]
  sites: string[]
}

export interface GenerateStudyDialogContextValue {
  title: string
  currentStep: number
  isLoading: boolean
  selection: Selection

  productOptions: SelectOption[]
  studyOptions: SelectOption[]
  environmentOptions: SelectOption[]
  countryOptions: SelectOption[]
  siteOptions: SelectOption[]

  getCurrentValues: () => FormValues
  getDefaultValues: () => FormValues
  getStepName: (num: number) => string | null
  goToNextStep: (values: FormValues) => void
  goToPreviousStep: () => void
  loadCountryOptions: (params: { sortDesc: boolean }) => Promise<{
    elements: SelectOption[]
    totalElements: number
    isCached: boolean
  }>
  loadSiteOptions: (params: { sortDesc: boolean }) => Promise<{
    elements: SelectOption[]
    totalElements: number
    isCached: boolean
  }>
  submit: () => Promise<void>
}

export const DialogContext = createContext<GenerateStudyDialogContextValue | null>(null)
